// Source: https://en.wikibooks.org/wiki/LaTeX/Colors

// name, red, green, blue, is predefined
type TexColorDef = [string, number, number, number, boolean?];

export const texColors: TexColorDef[] = [
  ["Apricot", 0xfb, 0xb9, 0x82],
  ["Aquamarine", 0, 0xb5, 0xbe],
  ["Bittersweet", 0xc0, 0x4f, 0x17],
  ["Black", 0x22, 0x1e, 0x1f, true],
  ["Blue", 0x2d, 0x2f, 0x92, true],
  ["BlueGreen", 0x00, 0xb3, 0xb8],
  ["BlueViolet", 0x47, 0x39, 0x92],
  ["BrickRed", 0xb6, 0x32, 0x1c],
  ["Brown", 0x79, 0x25, 0x00, true],
  ["BurntOrange", 0xf7, 0x92, 0x1d],
  ["CadetBlue", 0x74, 0x72, 0x9a],
  ["CarnationPink", 0xf2, 0x82, 0xb4],
  ["Cerulean", 0x00, 0xa2, 0xe3],
  ["CornflowerBlue", 0x41, 0xb0, 0xe4],
  ["Cyan", 0x00, 0xae, 0xef, true],
  ["Dandelion", 0xfd, 0xbc, 0x42],
  ["DarkOrchid", 0xa4, 0x53, 0x8a],
  ["Emerald", 0x00, 0xa9, 0x9d],
  ["ForestGreen", 0x00, 0x9b, 0x55],
  ["Fuchsia", 0x8c, 0x36, 0x8c],
  ["Goldenrod", 0xff, 0xdf, 0x42],
  ["Gray", 0x94, 0x96, 0x98, true],
  ["Green", 0x00, 0xa6, 0x4f, true],
  ["GreenYellow", 0xdf, 0xe6, 0x74],
  ["JungleGreen", 0x00, 0xa9, 0x9a],
  ["Lavender", 0xf4, 0x9e, 0xc4],
  ["LimeGreen", 0x8d, 0xc7, 0x3e],
  ["Magenta", 0xec, 0x00, 0x8c, true],
  ["Mahogany", 0xa9, 0x34, 0x1f],
  ["Maroon", 0xaf, 0x32, 0x35],
  ["Melon", 0xf8, 0x9e, 0x7b],
  ["MidnightBlue", 0x00, 0x67, 0x95],
  ["Mulberry", 0xa9, 0x3c, 0x93],
  ["NavyBlue", 0x00, 0x6e, 0xb8],
  ["OliveGreen", 0x3c, 0x80, 0x31],
  ["Orange", 0xf5, 0x81, 0x37, true],
  ["OrangeRed", 0xed, 0x13, 0x5a],
  ["Orchid", 0xaf, 0x72, 0xb0],
  ["Peach", 0xf7, 0x96, 0x5a],
  ["Periwinkle", 0x79, 0x77, 0xb8],
  ["PineGreen", 0x00, 0x8b, 0x72],
  ["Plum", 0x92, 0x26, 0x8f],
  ["ProcessBlue", 0x00, 0xb0, 0xf0],
  ["Purple", 0x99, 0x47, 0x9b, true],
  ["RawSienna", 0x97, 0x40, 0x06],
  ["Red", 0xed, 0x1b, 0x23, true],
  ["RedOrange", 0xf2, 0x60, 0x35],
  ["RedViolet", 0xa1, 0x24, 0x6b],
  ["Rhodamine", 0xef, 0x55, 0x9f],
  ["RoyalBlue", 0x00, 0x71, 0xbc],
  ["RoyalPurple", 0x61, 0x3f, 0x99],
  ["RubineRed", 0xed, 0x01, 0x7d],
  ["Salmon", 0xf6, 0x92, 0x89],
  ["SeaGreen", 0x3f, 0xbc, 0x9d],
  ["Sepia", 0x67, 0x18, 0x00],
  ["SkyBlue", 0x46, 0xc5, 0xdd],
  ["SpringGreen", 0xc6, 0xdc, 0x67],
  ["Tan", 0xda, 0x9d, 0x76],
  ["TealBlue", 0x00, 0xae, 0xb3],
  ["Thistle", 0xd8, 0x83, 0xb7],
  ["Turquoise", 0x00, 0xb4, 0xce],
  ["Violet", 0x58, 0x42, 0x9b, true],
  ["VioletRed", 0xef, 0x58, 0xa0],
  ["White", 0xff, 0xff, 0xff, true],
  ["WildStrawberry", 0xee, 0x29, 0x67],
  ["Yellow", 0xff, 0xf2, 0x00, true],
  ["YellowGreen", 0x98, 0xcc, 0x70],
  ["YellowOrange", 0xfa, 0xa2, 0x1a],
];

// TODO: здесь не все predefined colors

export const findNearestColor = (
  red: number,
  green: number,
  blue: number,
  inPredefined: boolean
): number => {
  let minDist = Number.MAX_SAFE_INTEGER;
  let pos = 0;
  for (let i = 0; i < texColors.length; i++) {
    const [, r, g, b, predefined] = texColors[i]!;
    if (inPredefined && !predefined) continue;
    const dr = red - r;
    const dg = green - g;
    const db = blue - b;
    const dist = dr * dr + dg * dg + db * db;
    if (dist < minDist) {
      pos = i;
      minDist = dist;
    }
  }
  return pos;
};
